<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xdmlBk/tc-custom/9781614233282.jpg?1688954040351" alt="This image is the cover for the book North Carolina in the Civil War, Civil War Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">North Carolina in the Civil War, Civil War Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Civil War scholar Michael Hardy delves into the story of North Carolina's Confederate past, from civilians to soldiers, as these Tar Heels proved they were a force to be reckoned with.</b></p><br/><p>"First at Bethel, farthest at Gettysburg and Chickamauga and last at Appomattox" is a phrase that is often used to encapsulate the role of North Carolina's Confederate soldiers. Tar Heels witnessed the pitched battles of New Bern, Averysboro and Bentonville, as well as incursions like Sherman's March and Stoneman's Raid.  The state was one of the last to leave the Union but contributed more men and sustained more dead than any other Southern state. This inclusive history of the Old North State is a must-read for any Civil War buff!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael C. Hardy
      </h2>
      
      <p class="authorDescription body article">Michael Hardy is a historian and author, who has written an array of articles, blog posts and over 17 books including Civil War Charlotte, North Carolina in the Civil War and A Short History of Watauga County. Hardy was awarded the 2010 Historian of the Year by the North Carolina Society of Historians.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?013b281c